import React, { useEffect } from 'react';
import { find, propEq } from 'ramda';
import { Field, formValueSelector, change } from 'redux-form';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';

import Fields from 'components/Fields';
import { wizardStyles } from 'components/Forms/Wizard/wizardUtils';
import StoreProvider from 'components/StoreProvider/StoreProvider';
import { useFormatMessage } from 'components/IntlProvider';

const { connect, selectors } = StoreProvider;

interface GroupSizeProps {
  sizeRange: {
    min: number;
    max: number;
  };
  size: string;
  goalSizeRange: {
    audience_group_size: number;
  };
  setAudienceGroupSizeInitialValue: (value: number) => void;
}

const GroupSize = ({
  sizeRange,
  size,
  goalSizeRange: { audience_group_size },
  setAudienceGroupSizeInitialValue,
}: GroupSizeProps) => {
  const classes = wizardStyles();
  const { max } = sizeRange;
  const initialValue = size || audience_group_size;
  const t = useFormatMessage();

  useEffect(() => {
    if (!size) {
      setAudienceGroupSizeInitialValue(Number(initialValue));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Typography
        component="h2"
        variant="subtitle1"
        color="inherit"
        className={classes.subtitle}
      >
        {t('fields.wizard.audiencegroupsize', 'Audience Group Size')} (
        <b>
          {Number(initialValue).toLocaleString(undefined, {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
          })}
        </b>
        )
      </Typography>
      <Grid item xs={12} className={classes.slider}>
        <Field
          component={Fields.Slider}
          name="audience_group_size"
          min={audience_group_size}
          max={max}
          step={10}
          initialValue={initialValue}
        />
      </Grid>
    </>
  );
};

const wizardSelector = formValueSelector('wizard');

export default connect(
  (state) => ({
    sizeRange: selectors.assistantSelectors.sizeRange(state),
    goals: selectors.assistantSelectors.goals(state),
    goalSizeRange: find(
      propEq('id', parseInt(wizardSelector(state, 'research_goal'), 10))
    )(selectors.assistantSelectors.goals(state)),
  }),
  (dispatch) => ({
    setAudienceGroupSizeInitialValue: (initialValue: number) =>
      dispatch(change('wizard', 'audience_group_size', initialValue)),
  })
)(GroupSize);
